import { render, staticRenderFns } from "./ProductsReportModule.vue?vue&type=template&id=1f15f61a"
import script from "./ProductsReportModule.vue?vue&type=script&lang=js"
export * from "./ProductsReportModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports